import { ContentType, PaymentsComparisonModalV2 } from 'api/contentful/contentTypes.cloverdotcom';
import { useContentful } from 'hooks/useContentful';

export function usePaymentsComparisonModal() {
  const pricingComparisonModal = useContentful<PaymentsComparisonModalV2>({
    contentType: ContentType.PAYMENTS_COMPARISON_MODAL_V2,
  });
  return pricingComparisonModal?.data?.[0];
}
